import React, { useEffect } from 'react';

const Layout = ({ children }) => {
  useEffect(() => {
  if (!document.querySelector(`script[src="https://www.googletagmanager.com/gtag/js?id=G-BMM3WZJJXL"]`)) {
    const script1 = document.createElement('script');
    script1.src = "https://www.googletagmanager.com/gtag/js?id=G-BMM3WZJJXL";
    script1.async = true;
    document.head.appendChild(script1);
  }

  if (!document.getElementById("gtag-init")) {
    const script2 = document.createElement('script');
    script2.id = "gtag-init";
    script2.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      function gtag() { dataLayer.push(arguments); }
      gtag('js', new Date());
      gtag('config', 'G-BMM3WZJJXL');
    `;
    document.head.appendChild(script2);
  }
}, []);

  return (
    <div>
      {children}
    </div>
  );
};

export default Layout;
